module.exports = __webpack_public_path__ + "static/media/kid17.f4670f48.png";